import { Component } from '@angular/core';
import { CbWebApi } from '../../services/cb-webapi';

@Component({
  selector: 'cb-unauthorize',
  templateUrl: './error-unauthorize.component.html',
})
export class CbUnauthorizeComponent {
  constructor(private cbWebApi: CbWebApi) {}

  gotoLogin() {
    this.cbWebApi.returnToAuthorizePage();
  }
}
